import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../assets/css/ChatWidget.css';

const ChatWidget = () => {
    const [chatOpen, setChatOpen] = useState(false);
    const [chatHistory, setChatHistory] = useState([]);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showDetails, setShowDetails] = useState({});
    const chatContentRef = useRef(null);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const toggleChat = () => setChatOpen(!chatOpen);

    const toggleDetails = (index) => {
        setShowDetails(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const handleSend = async (text = message) => {
        if (!text.trim()) return;

        setIsLoading(true);
        const userMessage = {
            sender: 'user',
            text,
            timestamp: new Date().toISOString()
        };
        setChatHistory(prev => [...prev, userMessage]);
        setMessage('');

        try {
            const res = await axios.post(`${API_BASE_URL}/v1/companyAdmin/ai-chat/chat`, {
                message: text
            });

            const botMessage = {
                sender: 'bot',
                text: res.data.reply,
                data: res.data.data,
                timestamp: new Date().toISOString()
            };

            setChatHistory(prev => [...prev, botMessage]);
        } catch (err) {
            const errorMessage = {
                sender: 'bot',
                text: err.response?.data?.error ||
                    "Sorry, I couldn't process your request. Please try again.",
                isError: true,
                timestamp: new Date().toISOString()
            };
            setChatHistory(prev => [...prev, errorMessage]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        alert('Copied to clipboard!');
    };

    const handleOptionClick = (option) => {
        handleSend(option);
    };

    useEffect(() => {
        if (chatContentRef.current) {
            chatContentRef.current.scrollTop = chatContentRef.current.scrollHeight;
        }
    }, [chatHistory, showDetails]);

    const formatDate = (timestamp) => {
        return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const predefinedQuestions = [
        {
            title: 'FIND EMPLOYEES',
            options: [
                'Show me Associate QA position employee',
                'Show me Supervisor position employee',
            ]
        },
        {
            title: 'ANALYZE DATA',
            options: [
                'Who are our top 3 HR?',
                'show me hr position employee',
            ]
        }
    ];

    return (
        <>
            <button id="openChatBtn" onClick={toggleChat}>
                <img src="/images/buttonlogo.jpg" alt="Open Chat" />
            </button>

            {chatOpen && (
                <div id="chatPopup">
                    <div className="chat-header">
                        <span>Developer Matching Assistant <span className="beta-badge">Beta</span></span>
                        <span className="close" onClick={toggleChat}>&times;</span>
                    </div>

                    <div className="chat-content" ref={chatContentRef}>
                        {chatHistory.map((msg, idx) => (
                            <div
                                key={idx}
                                className={`chat-bubble ${msg.sender === 'user' ? 'user-msg' : 'bot-msg'} ${msg.isError ? 'error-msg' : ''}`}
                            >
                                {msg.text.split('\n').map((line, i) => {
                                    if (line.match(/^\d+\. .+:$/)) {
                                        return <div key={i} className="candidate-name">{line}</div>;
                                    } else if (line.startsWith('   •')) {
                                        return <div key={i} className="candidate-detail">{line.replace('•', '')}</div>;
                                    } else {
                                        return (
                                            <React.Fragment key={i}>
                                                {line}
                                                <br />
                                            </React.Fragment>
                                        );
                                    }
                                })}
                                {msg.sender === 'bot' && !msg.isError && (
                                    <div className="chat-icons">
                                        <span onClick={() => handleCopy(msg.text)} title="Copy">📋</span>
                                        <span title="Thumbs up">👍</span>
                                        <span title="Thumbs down">👎</span>
                                    </div>
                                )}
                            </div>
                        ))}

                        {chatHistory.length === 0 && (
                            <div className="chat-section">
                                <div className="chat-section-title">Try asking about</div>
                                {predefinedQuestions.map((section, index) => (
                                    <div key={index} className="chat-section-group">
                                        <div className="chat-section-subtitle">{section.title}</div>
                                        {section.options.map((option, idx) => (
                                            <div
                                                key={idx}
                                                className="chat-option"
                                                onClick={() => handleOptionClick(option)}
                                            >
                                                {option}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="chat-input">
                        <input
                            type="text"
                            placeholder="Ask anything..."
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                        />
                        <button onClick={() => handleSend()}>Send</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ChatWidget;